import React from "react";
import { Switch, Theme, WithStyles } from "@material-ui/core";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import { observer } from "mobx-react";

const styles = (theme: Theme) => createStyles({});

export interface ToggleSwitchProps extends WithStyles<typeof styles> {
  handleChange: (checked: boolean) => void;
  value: boolean;
  disabled?: boolean;
}

@observer
export class ToggleSwitch extends React.Component<ToggleSwitchProps> {
  public constructor(props: ToggleSwitchProps) {
    super(props);
  }

  private handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.props.handleChange(event.target.checked);
  };

  public render() {
    return (
      <Switch
        checked={this.props.value}
        onChange={this.handleChange}
        disabled={this.props.disabled}
        color="primary"
      />
    );
  }
}

export const ToggleSwitchComponent = withStyles(styles, { withTheme: true })(
  ToggleSwitch
);
